<template>
  <ul
    data-qa="brief_details"
    class="d-flex flex-column gr-3 text-body-1 text-secondary--text"
  >
    <li>
      {{ t('Получайте процент от потраченной суммы в виде бонусов', options) }}
    </li>
    <li
      data-qa="brief_details_max_payment_percent"
      :data-qa-percent="maxPaymentPercent"
    >
      {{ t(
        'Оплачивайте бонусами до {maxPaymentPercent}% стоимости услуг клиники, 1 бонус = 1 {currencySymbol}',
        options,
      ) }}
    </li>
    <li>
      {{ t('Отслеживайте бонусы в приложении МедТочка после оформления карты лояльности', options) }}
    </li>
  </ul>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/common/LpuLoyaltyProgram/types'

const props = defineProps<{
  maxPaymentPercent: number
}>()
const { context }: ContextStore = useContextStore()

const { t, language } = I18NextVue
const options = {
  ns: language,
  maxPaymentPercent: props.maxPaymentPercent,
  currencySymbol: context.currency.symbol,
}
</script>
